import { createSchemaField } from '@formily/react';
import { useContext, useMemo } from 'react';
import { FormItem } from '@formily/antd-mobile';
export default (componentsSet, defaultComponent) => {
    const { components, pageContext } = useContext(window.__appContext);
    const importComponents = {};
    componentsSet.forEach((item) => {
        const componentName = item.split('.')[0];
        importComponents[componentName] = components[item] || components[componentName];
    });
    const SchemaField = useMemo(() => {
        return createSchemaField({
            components: {
                FormItem,
                ...importComponents,
                ...defaultComponent,
            },
            scope: {
                $this: pageContext,
            },
        });
    }, []);
    return SchemaField;
};
